import { Action, ReduxList } from "app/types/app-types"
import { ApiRequest } from "../types/api-types";

import { ImagickFont } from "shape-edit/components/imagickFontSelect";

export const GET_FONTS: ApiRequest = {
    CREATE: "GET_FONTS_CREATE",
    STARTED: "GET_FONTS_STARTED",
    SUCCESS: "GET_FONTS_SUCCESS",
    ERROR: "GET_FONTS_ERROR",
}

export const SET_IMAGICK_FONTS_TO_STORE = 'SET_IMAGICK_FONTS_TO_STORE'

export type ImagickFontsReduxList = ReduxList<ImagickFontsList>

export interface ImagickFontsList {
    fontsMap: ImagickFont[]
    allAvailableStyles: string[]
    allAvailableFamilies: FontFamilyType[]
}

export interface FontFamilyType {
    text_fontfamily: string
    image: string
    family: string
    styles: any
}

export type FontFamilyOptionType = FontFamilyType & { value: string }

export interface ImagickFontsType {
    data: ImagickFontsList
    isLoaded: boolean
    isLoading: boolean
}

const DefaultImagickFontsState: ImagickFontsReduxList = {
    data: [],
    isLoaded: false,
    isLoading: false,
    error: null,
    updated: null,
}

export function imagickFontsReducer(imagickFonts: ImagickFontsReduxList = DefaultImagickFontsState, action: Action<any>): ImagickFontsReduxList {
    switch (action.type) {
        case GET_FONTS.STARTED:
            return { ...imagickFonts, ...{ isLoading: true } }
        case GET_FONTS.SUCCESS:
            return { ...imagickFonts, ...{ isLoaded: true, isLoading: false, data: action.payload } }
        case GET_FONTS.ERROR:
            return { ...imagickFonts, ...{ isLoading: false, isLoaded: false, error: action.error } }
        case SET_IMAGICK_FONTS_TO_STORE:
            return { ...imagickFonts, ...{ isLoading: false, isLoaded: true, data: action.payload } }
        default:
            return imagickFonts
    }
}

export function setImagickFontsToStore(imagickFonts: ImagickFontsReduxList): Action<ImagickFontsReduxList> {
    return {
        type: SET_IMAGICK_FONTS_TO_STORE,
        payload: imagickFonts
    }
}